<template>
  <div class="w2-loading-mask">
    <div class="w2-loading-animate"></div>
  </div>
</template>

<script>
export default {
  name: "w2-loading",
};
</script>

<style>
/* 父级元素加上这个类，否则动画就是相对于整个页面的 */
.w2-loading-parent-relative {
  position: relative;
}
.w2-loading-mask {
  background-color: hsla(0, 0%, 100%, 0.9);
  min-height: 30px;
  position: absolute;
  z-index: 999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.w2-loading-animate {
  width: 30px;
  height: 30px;
  border: 2px solid #666;
  border-top-color: #ccc;
  border-right-color: #ccc;
  border-bottom-color: #ccc;
  border-radius: 100%;
  animation: circle infinite 0.75s linear;
}

@keyframes circle {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>